export default __webpack_public_path__ + "static/media/quiz-challenge-screenshot.0d9c019d.png";